var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions, CommonStates } from '../../localization/helpers.js';
import '../icon/Icon.js';
let ModalError = class ModalError extends LitElement {
    constructor() {
        super(...arguments);
        this.errorMessage = '';
    }
    render() {
        return html `
      <div class="modal">
        <div class="modal-header">
          <basic-icon
            name="warning"
            size="24"
            .label=${msg('Warning', { id: 'common.state.warning', desc: 'Warning icon alt text' })}
          ></basic-icon>
          <span>${CommonStates.error()}</span>
        </div>
        <p>${this.errorMessage}</p>
        <button @click="${this._closeModal}">${CommonActions.close()}</button>
      </div>
    `;
    }
    _closeModal() {
        this.remove();
    }
};
ModalError.styles = css `
    :host {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    }

    .modal {
      background: white;
      padding: 20px 30px;
      border-radius: 10px;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      text-align: center;
      max-width: 400px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .modal-header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 15px;
      color: #b71c1c; /* rouge foncé */
      font-weight: bold;
      font-size: 1.2rem;
    }

    .modal-header basic-icon {
      color: inherit;
    }

    .modal p {
      margin: 0;
      color: #333;
    }

    .modal button {
      margin-top: 20px;
      padding: 8px 16px;
      border: none;
      background: #d32f2f; /* rouge vif */
      color: white;
      border-radius: 5px;
      cursor: pointer;
      font-weight: bold;
      transition: background 0.3s;
    }

    .modal button:hover {
      background: #9a0007;
    }
  `;
__decorate([
    property({ type: String })
], ModalError.prototype, "errorMessage", void 0);
ModalError = __decorate([
    localized(),
    customElement('modal-error')
], ModalError);
export { ModalError };
//# sourceMappingURL=ModalError.js.map